if (!customElements.get('gm-order-info')) {
  customElements.define('gm-order-info', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const variants = JSON.parse(this.querySelector('script').textContent);
      const ja = document.documentElement.lang.startsWith('ja');
      this.closest('.product-info').addEventListener('on:variant:change', (event) => {
        const variant = variants.find((item) => item.id === event.detail.variant?.id);
        const sampleLink = this.querySelector('.gm-order-sample');
        if (sampleLink) {
          const supported = !!variant?.sample_supported;
          if (supported) {
            const url = new URL(sampleLink.dataset.sampleUrl, location.origin);
            url.searchParams.set('source_variant', variant.id);
            sampleLink.href = url.href;
            sampleLink.removeAttribute('aria-disabled');
            sampleLink.removeAttribute('tabindex');
            sampleLink.removeAttribute('role');
          } else {
            sampleLink.removeAttribute('href');
            sampleLink.setAttribute('role', 'link');
            sampleLink.setAttribute('aria-disabled', 'true');
            sampleLink.setAttribute('tabindex', '-1');
          }
          sampleLink.querySelector('[data-sample-label]').textContent = supported ? (ja ? 'カットサンプルを見る' : 'Browse material samples') : (ja ? 'カットサンプルなし' : 'No material sample');
          sampleLink.querySelector('[data-sample-note]').textContent = supported ? (ja ? '購入前に実物を確認' : 'See the material before you buy') : (ja ? 'ご用意がありません' : 'Not offered for this option');
          sampleLink.querySelector('[data-sample-arrow]').hidden = !supported;
        }
        const available = !!variant?.available && !variant.backordered;
        this.dataset.stock = String(available);
        this.querySelector('.gm-order-status').textContent = available ? (ja ? '在庫あり' : 'In stock') : (ja ? '在庫なし' : 'Out of stock');
        this.querySelector('.gm-order-lead').textContent = this.dataset.lead || (available ? this.dataset.defaultLead : (ja ? '入荷時期未定' : 'Restock date TBD'));
        this.querySelector('.gm-order-dispatch').hidden = !variant;
      });
    }
  });
}
